export default "__VITE_ASSET__DnPZQeRn__"